
// Core
import React, { lazy, useEffect, useState } from 'react';
import {
    Card, Row, Col, Table, Spin, Tooltip, Modal, notification, Form, Input, Button
} from 'antd';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import Moment from 'moment';
import 'moment/locale/es-mx';
import { SearchOutlined } from '@ant-design/icons';

// App
import {
    servicioListAction
} from '../../../redux/administracion/servicios/actionCreator';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { TableWrapper } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';

const { Search } = Input;

const BuscadorProductosServicios = ({ callbackAction }) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.responseReducer.loading);
    const registros = useSelector(state => state.ServicioReducer.data);
    const [modalVisible, setModalVisible] = useState(false);
    const dataSource = [];

    const onHandleSearch = (value) => {
        dispatch(servicioListAction('clinica', value));
        setModalVisible(true);
    }

    const sendRegistroToParent = (registro) => {
        callbackAction(registro);
        setModalVisible(false);
    }

    if (registros.length)
        registros.map((record, key) => {
            const { id, categoria, nombre, precio_base, precio_pad, precio_primer_servicio, porcentaje_descuento_pad, monto_anticipo_requerido } = record;
            const keyR = Math.floor(Math.random() * 999);;
            let newRecord = {};
            newRecord.record = record;
            newRecord.key = keyR;

            return dataSource.push({
                key: keyR,
                categoria,
                nombre,
                precio_base: <span>$ {parseFloat(precio_base).toFixed(2)}</span>,
                precio_pad: <span>$ {parseFloat(precio_pad).toFixed(2)}</span>,
                precio_primer_servicio,
                porcentaje_descuento_pad,
                monto_anticipo_requerido,
                action: (
                    <div style={{ textAlign: 'right' }}>
                        <Button size="small" type="primary" onClick={() => sendRegistroToParent(newRecord)}>
                            Agregar
                        </Button>

                    </div>
                ),
            });
        });

    const columns = [
        {
            title: 'Categoria',
            dataIndex: 'categoria',
            key: 'categoria',
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
        },
        {
            title: 'Precio regular',
            dataIndex: 'precio_base',
            key: 'precio_base',
        },
        {
            title: 'Precio PAD',
            dataIndex: 'precio_pad',
            key: 'precio_pad',
        },
        {
            title: 'Acciones',
            dataIndex: 'action',
            key: 'action',
        },
    ];


    return (
        <>
            <Card className='noprint'>
                <Row gutter={24}>
                    <Col md={24} lg={24} sm={24}>
                        <Search
                            placeholder="Buscar membresias, servicios dentales o productos"
                            allowClear
                            enterButton="Buscar"
                            onSearch={onHandleSearch}
                            prefix={<SearchOutlined />}
                        />
                    </Col>
                </Row>
            </Card>
            <Modal
                title="Catálogo de productos y servicios"
                centered
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                width='80%'
                footer={[]}
            >
                <Row gutter={24}>
                    <Col md={24} lg={24} sm={24}>
                        <div>
                            <TableWrapper>
                                <Table
                                    size='small'
                                    pagination={{ pageSize: 20, showSizeChanger: true }}
                                    dataSource={dataSource}
                                    columns={columns}
                                    locale={{ emptyText: 'Sin registros' }}
                                />
                            </TableWrapper>
                        </div>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default BuscadorProductosServicios;
